import { FC } from "react";
import Image from "next/image";

import IsCheckedIcon from "@public/icons/check_ring_round.svg";

import styles from "./topping-card.module.css";

type Props = {
  data: {
    name: string;
    price: number;
  };
  isSelected: boolean;
  toggleSelected: () => void;
};

export const ToppingCard: FC<Props> = ({
  data,
  isSelected,
  toggleSelected,
}) => {
  const { name, price } = data;

  return (
    <div
      className={`${styles.toppingCard} ${isSelected ? styles.isSelected : ""}`}
      onClick={toggleSelected}
    >
      {isSelected && (
        <Image
          src={IsCheckedIcon}
          alt={"Выбран"}
          className={styles.selectedIcon}
        />
      )}
      <div className={styles.name}>{name}</div>
      <div className={`${styles.price}`}>{`+ ${price} ₽`}</div>
    </div>
  );
};
